/*
  Шаблон обложки для одного формата книги (top-level коллекция covers/{coverId}).

  Один документ обслуживает все книжные шаблоны с этим обрезным форматом и стороной
  корешка — подбор идёт запросом по formatKey + spinSide, дублей по шаблонам нет.
  Внутри — варианты лицевой стороны (variants) и подколлекция pages.
*/

/* Ключ подбора: обрезной формат книги из template.printInfo.format. */
function getFormatKey (format) {
  return `${format.width}x${format.height}`
}

class CoverTemplate {
  _id
  _ref
  name
  formatKey
  spinSide
  pageFormat
  available
  variants
  pages

  constructor (ref, data, pages) {
    this._id = ref.id
    this._ref = ref
    this.name = data.name || ''
    this.formatKey = data.formatKey
    this.spinSide = data.spinSide || 'left'
    this.pageFormat = data.pageFormat
    this.available = data.available ?? false
    // [{ id, name, frontPageId, backPageId }] — вариантов может быть сколько угодно
    this.variants = data.variants || []
    // Page-инстансы из подколлекции covers/{coverId}/pages
    this.pages = pages || []
  }

  getVariant (variantId) {
    return this.variants.find((variant) => variant.id === variantId) || null
  }

  getPage (pageId) {
    return this.pages.find((page) => page._id === pageId) || null
  }
}

export { CoverTemplate, getFormatKey }
